(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nexgi-product-videos"] && !window.DesignMode) return;
  try {
    
  
  class KsShoppableVideos extends HTMLElement {
    constructor () {
      super()
   
      if (!document.querySelector('#swiper-script')) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js')
        script.setAttribute('id', 'swiper-script')
        document.head.appendChild(script)
      }
  
      this.slider
  
      setTimeout(() => { 
        this.slider = new window.Swiper(this.querySelector('.swiper'), this.splideOptions())
  
        this.slider.on('slideChange', () => {
          this.querySelector('.swiper').classList.add('swiper-is-changing')
          this.onSlideChange()
        })
  
        this.slider.on('slideChangeTransitionEnd', () => {
          this.querySelector('.swiper').classList.remove('swiper-is-changing')
        })
      }, 500)
  
      this.querySelectorAll('.ks-shoppable-videos-btn-play').forEach(btn => {
        btn.addEventListener('click', () => {
          const video = btn.closest('.ks-shoppable-videos-video-wrapper').querySelector('video')
          this.onVideoPlay(video)
        })
      })
      this.querySelectorAll('video').forEach(video => {
        video.addEventListener('click', () => {
          this.onVideoPlay(video)
        })
      })
    }
  
    splideOptions () {
      const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1
  
      /** @type {SwiperOptions} */
      const options = {
        rewind: true,
        speed: Number(this.dataset.sliderSpeed),
        breakpoints: {
          0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile },
          576: { slidesPerView: Number(this.dataset.breakpointSm) },
          768: { slidesPerView: Number(this.dataset.breakpointMd) },
          992: { slidesPerView: Number(this.dataset.breakpointLg) },
          1200: { slidesPerView: Number(this.dataset.breakpointXl) },
          1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
        },
        navigation: {
          enabled: this.dataset.sliderNav === 'true',
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev')
        },
        pagination: {
          enabled: this.dataset.sliderPagination === 'true',
          type: this.dataset.sliderPaginationType,
          el: '.swiper-pagination',
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: 2,
          renderFraction: function (currentClass, totalClass) {
            return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
          }
        },
        scrollbar: {
          enabled: this.dataset.sliderScrollbar === 'true',
          el: this.querySelector('.swiper-scrollbar'),
          draggable: true 
          // hide: true
        },
        autoplay: this.dataset.sliderAutoplay !== '0'
          ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
          : undefined,
        watchSlidesProgress: true, 
        mousewheel: {
          enabled: true,
          forceToAxis: true
        },
      }
      return options
    }
  
    onSlideChange () {
      this.querySelectorAll('.ks-shoppable-videos-card').forEach(elem => {
        elem.setAttribute('data-is-playing', 'false')
        elem.querySelector('video')?.pause()
      })
    }
  
    onVideoPlay (video) {
      const card = video.closest('.ks-shoppable-videos-card')
  
      this.querySelectorAll('.ks-shoppable-videos-card').forEach(elem => {
        if (elem.dataset.index !== card.dataset.index) {
          elem.setAttribute('data-is-playing', 'false')
          elem.querySelector('video')?.pause()
        }
      })
      
      if (card.dataset.isPlaying === 'true') {
        card.setAttribute('data-is-playing', 'false')
        video.pause()
      } else {
        card.setAttribute('data-is-playing', 'true')
        video.muted = false
        video.play()
      }
    }
  
  }
  customElements.define('ks-shoppable-videos', KsShoppableVideos)
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vid-ash"] && !window.DesignMode) return;
  try {
    
class KsShoppableVideos extends HTMLElement {
  constructor () {
    super();

    const initSlider = () => {
      this.slider = new window.Swiper(this.querySelector('.swiper'), this.splideOptions());
  
      this.slider.on('slideChange', () => {
        this.querySelector('.swiper').classList.add('swiper-is-changing');
        this.onSlideChange();
      });
  
      this.slider.on('slideChangeTransitionEnd', () => {
        this.querySelector('.swiper').classList.remove('swiper-is-changing');
      });
    };
  
    if (!window.Swiper) {
      if (!document.querySelector('#swiper-script')) {
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
        script.id = 'swiper-script';
        script.onload = initSlider; // Call once loaded
        document.head.appendChild(script);
      } else {
        // Wait until script loads if already added
        document.querySelector('#swiper-script').addEventListener('load', initSlider);
      }
    } else {
      initSlider(); // Swiper is already available
    }
  
    // Add video listeners
    this.querySelectorAll('.ks-shoppable-videos-btn-play').forEach(btn => {
      btn.addEventListener('click', () => {
        const video = btn.closest('.ks-shoppable-videos-video-wrapper').querySelector('video');
        this.onVideoPlay(video);
      });
    });
  
    this.querySelectorAll('video').forEach(video => {
      video.addEventListener('click', () => {
        this.onVideoPlay(video);
      });
    });
 
    // if (!document.querySelector('#swiper-script')) {
    //   const script = document.createElement('script')
    //   script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js')
    //   script.setAttribute('id', 'swiper-script')
    //   document.head.appendChild(script)
    // }

    // this.slider

    // setTimeout(() => { 
    //   this.slider = new window.Swiper(this.querySelector('.swiper'), this.splideOptions())

    //   this.slider.on('slideChange', () => {
    //     this.querySelector('.swiper').classList.add('swiper-is-changing')
    //     this.onSlideChange()
    //   })

    //   this.slider.on('slideChangeTransitionEnd', () => {
    //     this.querySelector('.swiper').classList.remove('swiper-is-changing')
    //   })
    // }, 500)

    // this.querySelectorAll('.ks-shoppable-videos-btn-play').forEach(btn => {
    //   btn.addEventListener('click', () => {
    //     const video = btn.closest('.ks-shoppable-videos-video-wrapper').querySelector('video')
    //     this.onVideoPlay(video)
    //   })
    // })
    // this.querySelectorAll('video').forEach(video => {
    //   video.addEventListener('click', () => {
    //     this.onVideoPlay(video)
    //   })
    // })
  }

  splideOptions () {
    const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1

    /** @type {SwiperOptions} */
    const options = {
      rewind: true,
      speed: Number(this.dataset.sliderSpeed),
      breakpoints: {
        0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile },
        576: { slidesPerView: Number(this.dataset.breakpointSm) },
        768: { slidesPerView: Number(this.dataset.breakpointMd) },
        992: { slidesPerView: Number(this.dataset.breakpointLg) },
        1200: { slidesPerView: Number(this.dataset.breakpointXl) },
        1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
      },
      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: this.dataset.sliderPaginationType,
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        }
      },
      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true 
        // hide: true
      },
      autoplay: this.dataset.sliderAutoplay !== '0'
        ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
        : undefined,
      watchSlidesProgress: true, 
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
    }
    return options
  }

  onSlideChange () {
    this.querySelectorAll('.ks-shoppable-videos-card').forEach(elem => {
      elem.setAttribute('data-is-playing', 'false')
      elem.querySelector('video')?.pause()
    })
  }

  onVideoPlay (video) {
    const card = video.closest('.ks-shoppable-videos-card')

    this.querySelectorAll('.ks-shoppable-videos-card').forEach(elem => {
      if (elem.dataset.index !== card.dataset.index) {
        elem.setAttribute('data-is-playing', 'false')
        elem.querySelector('video')?.pause()
      }
    })
    
    if (card.dataset.isPlaying === 'true') {
      card.setAttribute('data-is-playing', 'false')
      video.pause()
    } else {
      card.setAttribute('data-is-playing', 'true')
      video.muted = false
      video.play()
    }
  }

}
customElements.define('ks-shoppable-videos', KsShoppableVideos)


  } catch(e) { console.error(e); }
})();
})();
